import { Box, Checkbox, Dialog, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material'
import { MarketingButton } from '~/components/common/MarketingButton'

export const TermsDialog = ({
  termsUrl,
  privacyPolicyUrl,
  open,
  checked,
  loading,
  handleChecked,
  handleClick,
}: {
  termsUrl: string
  privacyPolicyUrl: string
  open: boolean
  checked: boolean
  loading: boolean
  handleChecked: VoidFunction
  handleClick: VoidFunction
}) => {
  return (
    <Dialog open={open}>
      <DialogTitle>プライバシーポリシー・利用規約が更新されました</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 'small' }} px={2} pb={1}>
          平素よりtoridori marketingをご利用いただきありがとうございます。
          <br />
          当サービスのプライバシーポリシーおよび利用規約が更新されましたので、ご確認をお願いいたします。
        </DialogContentText>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: '5px',
          }}
          p={1}
        >
          <Checkbox checked={checked} onChange={handleChecked} />
          <Typography variant="subtitle2">
            <a target="_blank" rel="noreferrer noopener" href={termsUrl}>
              利用規約
            </a>
            、
            <a target="_blank" rel="noreferrer noopener" href={privacyPolicyUrl}>
              プライバシーポリシー
            </a>
            に同意する
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'end' }} pt={1}>
          <MarketingButton disabled={!checked} loading={loading} variant="contained" onClick={handleClick}>
            同意してはじめる
          </MarketingButton>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
